export const heurekaSliderOptions = (_instance, _options, maxVisibleItems) => {
    let responsiveItemCounts = {
        1280: 3.5,
        1024: 1.3,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = Math.min(responsiveItemCounts[resolution], Number(maxVisibleItems));

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: 1,
            spaceBetween: 16,
            cssMode: true,
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 16,
        cssMode: true,
        breakpoints: breakpoints,
        pagination: {
            ..._options.pagination,
            dynamicBullets: false,
        }
    }
}
